import {ClipPath, Defs, G, Path, Rect, Svg} from 'react-native-svg';

const PlusIcon = ({color}: {color: string}) => (
  <Svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <G clip-Path="url(#clip0_307_4569)">
      <Path d="M3 9H15" stroke={color} strokeWidth="1.5" />
      <Path d="M9 3V15" stroke={color} strokeWidth="1.5" />
    </G>
    <Defs>
      <ClipPath id="clip0_307_4569">
        <Rect width="18" height="18" fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default PlusIcon;
